import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'numbersToPersian' })
export class NumbersToPersianPipe implements PipeTransform {
  transform(input: string): string {
    if (input === undefined) {
      return '-';
    }
    let inPersian = '';
    const mapping = {
      '1': '۱',
      '2': '۲',
      '3': '۳',
      '4': '۴',
      '5': '۵',
      '6': '۶',
      '7': '۷',
      '8': '۸',
      '9': '۹',
      '0': '۰'
    };
    if (input != null) {
      input = input.toString();
      for (let i = 0; i < input.length; i++) {
        if (mapping[input[i]]) {
          inPersian += mapping[input[i]];
        }
        // tslint:disable-next-line:one-line
        else {
          inPersian += input[i];
        }
      }
    }
    return inPersian;
  }
}


declare var moment: any;
@Pipe({ name: 'persianDate' })
export class DateToPersian implements PipeTransform {
  transform(input: string): string {
    if (input) {
      return moment(input).format('jYYYY/jMM/jDD');
    }
  }
}


@Pipe({ name: 'dayFilter' })
export class DayFilterPipe implements PipeTransform {
  transform(input) {
    if (input === 0) {
      return 'هر روز';
    } else { return input+ ' روز در میان'; }


  }
}
@Pipe({ name: 'weekFilter' })
export class WeekFilterPipe implements PipeTransform {
  transform(input) {
    if (input === 0) {
      return 'هر هفته';
    } else { return input + ' هفته در میان'; }


  }
}

@Pipe({ name: 'monthFilter' })
export class MonthFilterPipe implements PipeTransform {
  transform(input) {
    if (input === 0) {
      return 'هر ماه';
    } else { return input + ' ماه در میان'; }


  }
}





@Pipe({ name: 'yearFilter' })
export class YearFilterPipe implements PipeTransform {
  transform(input) {
    if (input === 0) {
      return 'هر سال';
    } else { return input + ' سال در میان'; }


  }
}
@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {
  }
  transform(value: string) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}



// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/app.pipe.ts